import javaSetting from '@/bin/javaSetting'
import { fetchEventSource } from '@microsoft/fetch-event-source';

class NoWordError extends Error {
    code = 'E_NO_WORD'
}

// 敏感词
class SensitiveWordError extends Error {
    code = 'E_SENSITIVE_WORD'
}

// 未知错误
class UnknownError extends Error {
    code = 'E_UNKNOWN'
}
export function getAIGCRes(data, {
    onMessage,
    // onClose,
    onError,
    abortController,
}) {
    // 本地开发用pre吧，pre的支持跨域
    let url = `${javaSetting}/tts-web-api/v1/aiDoc/aiGenerate?articleId=${data.articleId}&projectId=${data.projectId||''}&ww_token=${data.ww_token}&taskId=${data.taskId}`

    return fetchEventSource(url, {
        method: 'POST',
        // credentials: "include",
        headers: {
            "Content-Type": "application/json",
            "accept": "text/event-stream",
            // 'X-Accel-Buffering': 'no'
        },
        body: JSON.stringify(data.body),
        signal: abortController?.signal,
        openWhenHidden: true,
        onmessage(event) {
            const data = JSON.parse(event.data)
            if (data.status === "fail") {
                if (data.message === 'SensitiveWordError') {
                    throw new SensitiveWordError('内容政治敏感，请修改后再次使用')
                } else {
                    throw new UnknownError('请求出错，请稍后重试')
                }
            } else if (data.status === 'error') {
                console.log('getAIGCRes onmessage:', data)
                // 字数不足
                throw new NoWordError(data.message || '可用字数不足，请先充值')
            } else {
                
                const text = data.results.reduce((text, item) => {
                    if (!item.content) return text
                    return text + item.content.join('')
                }, '')
                const prevChat = data.previous_chat
                onMessage({
                    text,
                    prevChat,
                    status: data.status
                })
            }
        },
        onerror(error) {
            console.log('getAIGCRes onerror:', error)
            if (!(error instanceof NoWordError) &&
                !(error instanceof SensitiveWordError)) {
                error = new UnknownError('请求失败，请重试')
            }
            onError && onError(error)
            abortController?.abort()
            throw error
        }
    });

}

